import axios from 'axios';
import systemApi from '@/lib/system-axios';
import { config } from '@/config/env.config';
import { attachAxiosSentryHandlers } from '@/observability/sentry.axios';

// Instância sem auth e sem interceptors de erro — para chamadas públicas silenciosas
const publicHttp = axios.create({ baseURL: config.api.baseUrl });
attachAxiosSentryHandlers(publicHttp);

export interface PlatformSettings {
  public_signup_enabled: boolean;
  default_plan_id: string | null;
  maintenance_mode: boolean;
  maintenance_message: string;
  support_email: string;
  audit_log_retention_days: number;
}

export interface PublicSettings {
  public_signup_enabled: boolean;
  maintenance_mode: boolean;
  maintenance_message: string;
  support_email: string;
}

class PlatformSettingsService {
  async getAll(): Promise<PlatformSettings> {
    const res = await systemApi.get<PlatformSettings>('/admin/platform-settings');
    return res.data;
  }

  async update(partial: Partial<PlatformSettings>): Promise<PlatformSettings> {
    const res = await systemApi.patch<PlatformSettings>('/admin/platform-settings', partial);
    return res.data;
  }

  async purgeLogs(): Promise<{ deleted: number }> {
    const res = await systemApi.post<{ deleted: number }>('/admin/platform-settings/purge-logs');
    return res.data;
  }

  async getPublic(): Promise<PublicSettings> {
    const res = await publicHttp.get<PublicSettings>('/platform/public-settings');
    return res.data;
  }
}

export const platformSettingsService = new PlatformSettingsService();
